// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"26a7caa9","340":"93bf5fa3","344":"6d07da2c","400":"966fd164","420":"ade3e0a7","624":"ac209d16","940":"d787f2f9"}[chunkId] + ".chunk.js";
};